import { OrderProduct } from "ts/api/order";
import { getItem, writeItem } from "tools/localStorage";
import { LocalStorageProduct } from "ts/api/product";

export const removeOrderProductsFromCart = (
  orderProducts: OrderProduct[]
): void => {
  const cartProducts = getItem<LocalStorageProduct[]>("products", []);
  const newCartProducts = cartProducts.filter(
    (p) => !orderProducts.some((orderProduct) => orderProduct.id === p.id)
  );
  writeItem("products", newCartProducts);
};
